import {Box, Chip, Typography} from "@mui/material";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import {appliedCartDiscount, cartUnitPrice} from "./cart-pricing";
import {formatOrderMoney} from "../orders/order-money";

const AppliedDiscount = ({product, showBadge = true}) => {
    const {price, couponDiscount, currency} = product;

    const appliedDiscount = appliedCartDiscount(product);

    const isCoupon = appliedDiscount === couponDiscount;
    const hasDiscount = appliedDiscount > 0;
    const discountedPrice = cartUnitPrice(product);

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: 0.5,
            }}
        >
            {!hasDiscount ? (
                <Typography
                    variant="body2"
                    sx={{fontWeight: "medium", fontSize: "0.9rem"}}
                >
                    {formatOrderMoney(discountedPrice, currency)}
                </Typography>
            ) : (
                <>
                    {/* Original price */}
                    <Typography
                        variant="caption"
                        sx={{
                            textDecoration: "line-through",
                            color: "text.disabled",
                            fontSize: "0.75rem",
                        }}
                    >
                        {formatOrderMoney(price, currency)}
                    </Typography>

                    {/* Discounted price + badge */}
                    <Box sx={{display: "flex", flexWrap: "wrap", alignItems: "center", gap: 0.5}}>
                        <Typography
                            variant="body2"
                            sx={{
                                color: "success.main",
                                fontWeight: "bold",
                                fontSize: "0.9rem",
                            }}
                        >
                            {formatOrderMoney(discountedPrice, currency)}
                        </Typography>

                        {showBadge && <Chip
                            label={`-${appliedDiscount}%`}
                            size="small"
                            color={isCoupon ? "primary" : "error"}
                            icon={
                                isCoupon ? (
                                    <LocalOfferIcon sx={{fontSize: "0.9rem"}}/>
                                ) : null
                            }
                            sx={{
                                fontSize: "0.7rem",
                                height: 18,
                                "& .MuiChip-label": {px: 0.5},
                            }}
                        />}
                    </Box>
                </>
            )}
        </Box>
    );
};

export default AppliedDiscount;
